/**
 * Off-canvas behavior for the shop/category sidebar below 950px — see
 * inc/quick-order.php's render_toolbar() for the "Filtry" button and
 * inc/category-archive.php's open_layout()/render_sidebar() for the
 * overlay/close-button markup this drives.
 */

import './index.scss';

const toggle = document.querySelector('[data-shop-sidebar-toggle]');
const sidebar = document.querySelector('[data-shop-sidebar]');
const overlay = document.querySelector('[data-shop-sidebar-overlay]');
const closeButton = sidebar?.querySelector('[data-shop-sidebar-close]');

if (toggle && sidebar && overlay) {
	const open = () => {
		sidebar.classList.add('is-open');
		overlay.hidden = false;
		toggle.setAttribute('aria-expanded', 'true');
		document.body.classList.add('shop-sidebar-locked');
	};

	const close = () => {
		sidebar.classList.remove('is-open');
		overlay.hidden = true;
		toggle.setAttribute('aria-expanded', 'false');
		document.body.classList.remove('shop-sidebar-locked');
	};

	toggle.addEventListener('click', () => {
		if (sidebar.classList.contains('is-open')) {
			close();
		} else {
			open();
		}
	});

	closeButton?.addEventListener('click', close);
	overlay.addEventListener('click', close);

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && sidebar.classList.contains('is-open')) {
			close();
			toggle.focus();
		}
	});
}
